import { useWatchProfile } from '@/hooks/useWatchProfile'
import profileService from '@/services/profileService'
import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useUpdateGoogleCalendar = () => {
	const { execute: saveGoogleCalendar, isSuccess } =
		profileService.saveGoogleCalendarMutation()
	const { refetch } = useWatchProfile()
	const location = useLocation()

	const queryString = useMemo(
		() => new URLSearchParams(location.search),
		[location.search]
	)

	const code = useMemo(() => queryString.get('code'), [queryString])
	const refreshToken = useMemo(
		() => queryString.get('refreshToken'),
		[queryString]
	)
	const email = useMemo(() => queryString.get('email'), [queryString])

	useEffect(() => {
		if (code && refreshToken && email) {
			saveGoogleCalendar({
				calendario_code: code,
				calendario_refresh_token: refreshToken,
				calendario_email: email,
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [code, refreshToken, email])

	useEffect(() => {
		if (isSuccess) refetch()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess])
}
